
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 114 176","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M110.807 3.212V135.03h-9.003V13.77L16.687 4.713v5.654l-1.49-.279V3.212h95.61z","stroke":"#fff","stroke-width":"6","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.687 10.365v9.98l-1.49-.556v-9.702l1.49.278zM101.804 13.77v131.84l-9.004-.964V24.35L16.688 10.365V4.713l85.117 9.059z","stroke":"#fff","stroke-width":"6","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M92.8 24.35v131.818l-9.003-1.649V33.409l-67.11-18.632v-4.411L92.801 24.35z","stroke":"#fff","stroke-width":"6","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.687 10.366v9.98l-1.49-.557-4.512-1.692V9.252l4.512.835 1.49.279z","stroke":"#fff","stroke-width":"6","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M71.793 40.948v131.84l-68.6-25.679V15.291l4.49 1.67 3.002 1.136 4.512 1.692 1.49.557 55.105 20.602z","stroke":"#fff","stroke-width":"6","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M83.797 33.41v131.839l-12.004-3.341V40.948L16.687 20.346v-5.569l67.11 18.633zM16.687 14.777v5.569l-1.49-.557-4.512-1.692-3.001-1.135v-4.69l3 .835 4.513 1.242 1.49.428zM40.1 67.761l-23.413-8.78M51.743 89.242L16.687 76.114M51.743 106.375L16.687 93.247M3.192 15.291L15.197 3.212","stroke":"#fff","stroke-width":"6","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    